import { APPCONFIG } from '@/app.config';

const APIS = {
    URLS: {
        LOGOUT: APPCONFIG.ENDPOINTS.SECURITYURL + 'Account/Logout',

        USERS_SIMULATORS_QUERY: APPCONFIG.ENDPOINTS.SECURITYURL + 'simulatorusers/getusers',
        USERS_SIMULATORS_CREATE: APPCONFIG.ENDPOINTS.SECURITYURL + 'simulatorusers/createuser',
        USERS_SIMULATORS_DELETE: APPCONFIG.ENDPOINTS.SECURITYURL + 'simulatorusers/deleteuser',
        USERS_SIMULATORS_LOGIN: APPCONFIG.ENDPOINTS.SECURITYURL + 'simulatorusers/login',
        USERS_SIMULATORS_CHANGE_PASSWORD: APPCONFIG.ENDPOINTS.SECURITYURL + 'account/resetpassword',

        ADMIN_USERS_GET_ALL: APPCONFIG.ENDPOINTS.SECURITYURL + 'api/AdminUsers',
        ADMIN_USERS_GET_BY_ID: APPCONFIG.ENDPOINTS.SECURITYURL + 'api/AdminUsers/',
        ADMIN_USERS_CREATE: APPCONFIG.ENDPOINTS.SECURITYURL + 'api/AdminUsers',
        ADMIN_USERS_UPDATE: APPCONFIG.ENDPOINTS.SECURITYURL + 'api/AdminUsers/',
        ADMIN_USERS_DELETE: APPCONFIG.ENDPOINTS.SECURITYURL + 'api/AdminUsers/',
        ADMIN_USERS_TOGGLE_STATUS: APPCONFIG.ENDPOINTS.SECURITYURL + 'api/AdminUsers/toggle-status',
        ADMIN_USERS_CONFIRM_EMAIL: APPCONFIG.ENDPOINTS.SECURITYURL + 'api/AdminUsers/confirm-email',
        
        SIMULATE_PRODUCER: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/simulator/simulateproducer',
        
        ACTIONS_QUERY: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/simulator/getaudit',
        ACTIVITY_QUERY: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/simulator/getlogs?exception=false',
        ERRORS_QUERY: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/simulator/getlogs?exception=true',
        MESSAGES_QUERY: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/simulator/getcommunicationaudit',
        
        PRODUCER_AUTOCOMPLETE_BY_CUIT: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/datos/GetAutocompleteValues?e=Productor_CUIT',
        PRODUCER_AUTOCOMPLETE_BY_NAME: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/datos/GetAutocompleteValues?e=Productor_NOMBRE',

        NEWS_QUERY: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/news/NewsSearch',
        NEWS_CREATE: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/news/NewsCreate',
        NEWS_UPDATE: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/news/NewsUpdate',
        NEWS_DELETE: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/news/NewsDelete',
        SEND_NEWS: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/news/SendNews',
        
        PRODUCER: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/datos/GetComboValues?e=Productor',
        SECTOR: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/datos/GetComboValues?e=Sector&parentId=',
        TIPO_CONSULTA: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/datos/GetComboValues?e=TipoConsulta&parentId=',
        
        SCHEDULER_SAVE: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/scheduler/SaveSchedulerData',
        SCHEDULER_GET: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/scheduler/GetSchedulerData',

        STATISTICS_MODULO_MAS_VISITADO: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Simulator/GetModulos?period=',
        STATISTICS_USUARIOS_REGISTRADOS: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Simulator/GetUsuariosRegistrados',
        STATISTICS_ULTIMOS_ACCESOS: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Simulator/GetUltimosAccesos?period=',
        STATISTICS_PRODUCTORES_REGISTRADOS: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Simulator/GetProductoresRegistrados',

        PARAMETERS_GET: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Parameters/Parameters',
        PARAMETERS_SAVE: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Parameters/ParametersSave',
        CONFIGURATIONS: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/configurations',
        SECTORS: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/sectors',

        CONSULTA_SEND: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Communication/EnviarConsulta',
        AREA_CONTACT: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/AreaContact',

        // Comunicaciones
        COMMUNICATIONS_GET_ALL: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Communication/GetCommunications',
        COMMUNICATIONS_DELETE: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Communication/DeleteCommunication',
        COMMUNICATIONS_SEARCH: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Communication/SearchCommunication',
        COMMUNICATIONS_CONFIRM: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Communication/ConfirmCommunication',

        DOWNLOAD_CERTIFICADO_INDIVIDUAL: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Datos/CertificadoVT',
        DOWNLOAD_CERTIFICADO_INDIVIDUAL_TEMP: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Datos/CertificadoVT_Temp',
        DOWNLOAD_INVOICE: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Datos/Invoice',
        DOWNLOAD_ELECTRONIC_INVOICE: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/producer/Invoices/Download',
        DOWNLOAD_CERTIFICADO_COBERTURAS: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Datos/Coberturas',
        DOWNLOAD_CERTIFICADO_MATRIZ: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Datos/PolizaMatriz',
        DOWNLOAD_CERTIFICADO_PAGOSYLIQ: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Settlement/Certificado',
        DOWNLOAD_FILE:  APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/FileRepository/File',
        DELETE_FILE: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/FileRepository/',
        
        ACCOUNT_MANAGER_BY_CUIT: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/producer/AccountManagerByCuit',
        PRODUCER_BY_ID: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/producer/ProducerById',
        PRODUCER_BY_CUIT: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/producer/ProducerByCuit',
        UPDATE_PRODUCER_DATA: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/producer/UpdateProducerData',
        PRIMO_PORTAL_LINK: APPCONFIG.ENDPOINTS.PRODUCERURL + 'api/Settlement/portal-link'
    }
}
export { APIS };
